import clone from "lodash/clone";
import cloudinary from "cloudinary";
import { isString } from "lodash";
import logoAlt from "@irati/ui/images/logo-alt.svg";
import { PROFILE_IMAGE_SIZE } from "@irati-web/platform/src/constants/profile";
cloudinary.config({
    cloud_name: "perkbox"
});
/*
    Hidden
*/
var isMobile = function () {
    var mobile = 768;
    return (window.innerWidth && window.innerWidth < mobile);
};
var defaultImage = function (transformation) {
    var final = transformation[transformation.length - 1];
    return "https://placeholdit.imgix.net/~text?txtsize=33&txt=" +
        (final.width + "%C3%97" + final.height + "&w=" + final.width + "&h=" + final.height);
};
var getImage = function (url, transformation, defaultImageOverride) {
    var defImage = defaultImageOverride || defaultImage(transformation);
    if (!url || !isString(url)) {
        return defImage;
    }
    var cloudinaryUrl = getCloudinaryUrl(url);
    if (!cloudinaryUrl) {
        return defImage;
    }
    return cloudinary.url(cloudinaryUrl, { transformation: transformation, secure: true });
};
var defaultTransformation = function (width, height) {
    return clone([
        {
            width: width,
            height: height,
            crop: "crop"
        }
    ]);
};
/*
    EXPORTS
*/
export var getCloudinaryUrl = function (url) {
    return url.split("/perkbox/image/upload/")[1];
};
export var isCloudinaryUrl = function (url) {
    return url && getCloudinaryUrl(url);
};
export var getBannerImage = function (url) {
    var width = isMobile() ? 1600 : 1920;
    var height = isMobile() ? 600 : 350;
    var transformation = defaultTransformation(width, height);
    transformation.unshift({ width: width, height: height, crop: "fill" });
    return getImage(url, transformation);
};
export var getDealTileImage = function (url) {
    var width = isMobile() ? 600 : 720;
    var height = isMobile() ? 206 : 320;
    var transformation = defaultTransformation(width, height);
    transformation.unshift({ width: width, height: height, crop: "fill" });
    return getImage(url, transformation);
};
export var getThumbnailImage = function (url, effect) {
    if (effect === void 0) { effect = null; }
    var size = isMobile() ? 320 : 640;
    return getImage(url, [{ width: size, height: size, crop: "scale", effect: effect }]);
};
export var getProfileImage = function (url, effect, defaultImageOverride) {
    if (effect === void 0) { effect = null; }
    var transformation = { width: PROFILE_IMAGE_SIZE, height: PROFILE_IMAGE_SIZE, radius: "max", effect: effect };
    applyDprTransformation(transformation);
    return getImage(url, [transformation], defaultImageOverride);
};
export var getImageTransformed = function (url, transformation) {
    return getImage(url, transformation);
};
export var getImageSize = function (url, width, height) {
    return getImage(url, defaultTransformation(width, height));
};
export var getBrandLogo = function (url, width, height, sharpnessLevel, customTransformation) {
    if (sharpnessLevel === void 0) { sharpnessLevel = 100; }
    if (customTransformation === void 0) { customTransformation = {}; }
    var transformation = Object.assign({ width: width, height: height, effect: "sharpen:" + sharpnessLevel }, customTransformation);
    applyDprTransformation(transformation);
    return getImage(url, [transformation], logoAlt);
};
export var applyDprTransformation = function (transformation) {
    var isDoubleDensityDevice = window.devicePixelRatio && window.devicePixelRatio >= 2;
    if (isDoubleDensityDevice) {
        transformation.dpr = "2.0";
    }
    return transformation;
};
